module.exports = __webpack_public_path__ + "img/head_z.26f281e0.png";